import delve from "dlv";

let DUBLAB_PATHS = null;
// let DUBLAB_TAKEOVER = false;

export function defaultRedirect(to, from, next) {
  const fetchPaths = async () => {
    // fetch known paths from wordpress
    if (!DUBLAB_PATHS) {
      const response = await fetch(process.env.VUE_APP_API_ENDPOINT + "/paths");
      const json = await response.json();
      DUBLAB_PATHS = delve(json, "/paths.paths") || [];
    }

    // if this is a known path, render
    if (DUBLAB_PATHS.find((path) => new RegExp(`${path}/?$`).test(to.path))) {
      next();
    } else {
      // otherwise redirect to archive
      next("/archive" + to.path);
    }
  };

  fetchPaths();
}

export function homeRedirect(to, from, next) {
  // const fetchDrive = async () => {
  //   // fetch drive status from wordpress
  //   if (!DUBLAB_TAKEOVER) {
  //     const response = await fetch(process.env.VUE_APP_API_ENDPOINT_TAKEOVER);
  //     const json = await response.json();
  //     DUBLAB_TAKEOVER = json;
  //   }
  
  //   // redirect to drive if active
  //   if (DUBLAB_TAKEOVER.active) {
  //     next(DUBLAB_TAKEOVER.path);
  //   } else {
  //     next();
  //   }
  // };
  
  //fetchDrive();
  next();
}

